export default "__VITE_ASSET__DMlBhHFK__"